import { MedicalType } from "@qendo/medical/types";
import { useLocalSearchParams } from "expo-router";
import { MedicationForm } from "~/components/form/health-profile/MedicationForm";
import { Authorize } from "~/components/permission/Authorize";
import { Dismiss } from "~/components/permission/Dismiss";
import { useDismiss } from "~/providers/DismissProvider";
import { useMedical } from "~/providers/MedicalProvider";

const type = MedicalType.medication;

export default function EditMedication() {
    const { id }: { id: string } = useLocalSearchParams();
    const { findMedical } = useMedical();
    const { handleDismiss } = useDismiss();
    const medication = findMedical(type, id);

    if (!medication) {
        return <Dismiss />;
    }

    return (
        <Authorize ability="update" section="medications">
            <MedicationForm medication={medication} onRequestClose={handleDismiss} asRoute />
        </Authorize>
    );
}
